import { all } from "redux-saga/effects";
import { reportSaga } from "./reportSaga";
import { reportNhapHocSaga } from "./reportNhapHocSaga";
import { reportTuyenSinhSaga } from "./reportTuyenSinhSaga";
import { reportTamThuSaga } from "./reportTamThuSaga";
import { tongHopSinhVienSaga } from "./tongHopSinhVienSaga";

export default function* reportSagaWrapper() {
  yield all([
    reportSaga(),
    reportNhapHocSaga(),
    reportTuyenSinhSaga(),
    reportTamThuSaga(),
    tongHopSinhVienSaga(),
  ]);
}
